import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const Services = () => {
  const { t } = useLanguage();

  return (
    <Section id="services" bg="bg-brand-dark">
      <div className="text-center max-w-3xl mx-auto mb-20">
        <SectionHeading>{t.services.heading}</SectionHeading>
      </div>

      <div className="space-y-16">
        {t.services.categories.map((category, catIndex) => (
          <div key={catIndex} className="space-y-8">
            <div className="flex items-center gap-4">
              <h3 className="text-xl md:text-2xl font-bold text-brand-accent tracking-tight">
                {category.title}
              </h3>
              <div className="h-px flex-grow bg-brand-border/50"></div>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {category.items.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-brand-card border border-brand-border rounded-xl p-8 hover:border-brand-accent/40 transition-all duration-300 group flex flex-col h-full"
                >
                  <div className="w-12 h-12 bg-brand-dark rounded-lg flex items-center justify-center mb-6 text-brand-accent group-hover:scale-110 transition-transform duration-300">
                    <SafeIcon name={service.icon} className="w-6 h-6" />
                  </div>
                  <h4 className="text-xl font-bold text-brand-textHeading mb-4 leading-snug">
                    {service.title}
                  </h4>
                  <p className="text-brand-textMuted leading-relaxed text-sm flex-grow">
                    {service.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Services;